export default "__VITE_ASSET__S$2u7x$b__"